import {initApp} from '../state/initSlice'
import {getAllTags} from '../state/accountTagsSlice'
import {getChatRooms} from '../features/MessageCenter/messageCenterSlice'

const initializers = [
	initApp,
	getAllTags,
	getChatRooms
]

export default initializers